import React, { useEffect, useRef } from "react";
import "./settings-client.scss";
import {
  messageErrorPassword,
  userResetPassword,
  userUpdatePassword,
} from "../../../../store/actions/auth";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import DialogTitle from "../../../../components/modal-components/dialog-title";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog/Dialog";
import { Link } from "react-router-dom";

const PasswordClient = () => {
  const user = useSelector((state) => state.auth.user);
  const errorPassword = useSelector((state) => state.auth.errorPassword);
  const dispatch = useDispatch();
  const { register, errors, handleSubmit, watch } = useForm({});
  const password = useRef({});
  password.current = watch("password", "");
  const onSubmit = async (data) => {
    dispatch(userUpdatePassword(data));
  };

  useEffect(() => {
    document.title = "Изменение пароля";
  }, []);

  return (
    <div className="passwordClientWrapper">
      <h2>Изменение пароля</h2>
      <form
        onSubmit={(e) => e.preventDefault()}
        className="passwordClientContainer"
      >
        <label>Старый пароль</label>
        <input
          name="password_old"
          type="password"
          ref={register({
            required: "Вы должны указать пароль",
          })}
        />
        {errors.password_old && <span>{errors.password_old.message}</span>}
        {errorPassword === null || errorPassword === true ? null : (
          <span>{errorPassword}</span>
        )}
        <label>Новый пароль</label>
        <input
          name="password"
          type="password"
          ref={register({
            required: "Вы должны указать пароль",
            minLength: {
              value: 8,
              message: "пароль должен содержать не менее 6 символов",
            },
          })}
        />
        {errors.password && <span>{errors.password.message}</span>}

        <label>Повторите новый пароль</label>
        <input
          name="password_repeat"
          type="password"
          ref={register({
            validate: (value) =>
              value === password.current || "пароли не совпадают",
          })}
        />
        {errors.password_repeat && (
          <span>{errors.password_repeat.message}</span>
        )}

        <div className="changePasswordClientActions">
          <input
            type="submit"
            onClick={handleSubmit(onSubmit)}
            value="Изменить пароль"
          />
          <Link
            to={"/client/settings"}
            onClick={() => dispatch(messageErrorPassword(null))}
          >
            <Button>Отмена</Button>
          </Link>
        </div>
        <div className="resetPasswordClient">
          Если вы забыли пароль, нажмите на{" "}
          <b onClick={() => dispatch(userResetPassword(user.email))}>
            восстановить
          </b>
          , вам будет отправлено письмо с интрукцией на почту
        </div>
      </form>
      <Dialog
        open={errorPassword === true}
        aria-labelledby="form-dialog"
        fullWidth
        maxWidth={"xs"}
      >
        <DialogTitle id="form-dialog" />
        <DialogContent id="confirmPasswordContent">
          <h3>Пароль изменен</h3>
        </DialogContent>
        <DialogActions id="confirmPasswordAction">
          <Link
            to="/client/settings"
            onClick={() => dispatch(messageErrorPassword(null))}
          >
            <Button variant="contained" color="primary">
              Ок
            </Button>
          </Link>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default PasswordClient;
